module.exports = __webpack_public_path__ + "img/welding5.a5ea65fa.png";